import React, { useEffect, useLayoutEffect, useRef, useState } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "../Style/typo.css";
import "./assets/css/style-helpdesk.css";
import NavButton from "../homepage/header-banner/TopNavButton";
import Footer from "../homepage/footer/Footer";
import DeskIcon1 from "./assets/image/desk_icon1.png";
import DeskIcon2 from "./assets/image/desk_icon2.png";
import DeskIcon3 from "./assets/image/desk_icon3.png";
// import DeskIcon4 from "./assets/image/desk_icon4.png";
// import DeskIcon5 from "./assets/image/desk_icon5.png";
import DeskIcon6 from "./assets/image/desk_icon6.png";
import DeskIcon7 from "./assets/image/desk_icon7.png";
import FadeInSection from "../container/component/Fadeanimation/FadeInSection";


export function HelpDeskBanner() {
    const scrollToSection = (id, offset = 80) => {
        const el = document.getElementById(id);
        if (!el) return;
        const y = el.getBoundingClientRect().top + window.pageYOffset - offset;
        window.scrollTo({ top: y, behavior: "smooth" });
    };

    return (
        <div>
            <div className="helpdesk-banner">
                <div className="fit-wth">
                    <FadeInSection>
                        <div className="helpdesk-banner-content">
                            <div className="helpdesk-banner-left">
                                <p className="typo-32-mb">헬프데스크란 ?</p>
                                <p className="typo-21-sm helpdesk-desc">
                                    메일, 라이브챗, 전화 등 여러 채널로 들어오는 고객문의를 “헬프데스크” 라는 하나의 통합된 컨텍센터에서 관리합니다.<br/>
                                    담당자 배정 및 상태변경 , 메일 답변을 지원하고 내부 구성원 및 고객과 공유합니다.
                                </p>

                                <div className="helpdesk-btn-gr">
                                    <a className="helpdesk-url-btn typo-14" href="https://hanbiro.com/#/groupware-free-trial">
                                        <button className="btn--default btn--primary">데모 신청</button>
                                    </a>
                                    <a className="helpdesk-url-btn typo-14" href="https://hanbiro.com/#/pricing">
                                        <button className="btn--default btn--secondary">요금안내</button>
                                    </a>
                                </div>
                            </div>

                            <div className="helpdesk-banner-right">
                               <div className="helpdesk-banner-right">
                                    <div className="helpdesk-card-inner">
                                        <div className="helpdesk-card-grid">
                                            <button type="button" className="typo-21 helpdesk-card btn--default btn--secondary" aria-controls="ai-phone" onClick={() => scrollToSection('ai-phone')}>AI 전화</button>
                                            <button type="button" className="typo-21 helpdesk-card btn--default btn--secondary" aria-controls="ticket" onClick={() => scrollToSection('ticket')}>티켓</button>
                                            <button type="button" className="typo-21 helpdesk-card btn--default btn--secondary" aria-controls="customer" onClick={() => scrollToSection('customer')}>고객관리</button>
                                            <button type="button" className="typo-21 helpdesk-card btn--default btn--secondary" aria-controls="livechat" onClick={() => scrollToSection('livechat')}>라이브챗</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </FadeInSection>
                </div>
            </div>
        </div>
    );
}

export function HelpDeskBody() {
    return (
        <div>

                <div className="helpdesk-block">
                    <div className="fit-wth">
                        <FadeInSection>
                            <div className="helpdesk-advantage">
                                <div className="helpdesk-title">
                                    <p className="typo-32 typo-medium">헬프데스크 장점</p>
                                </div>

                                <div className="helpdesk-advantage-content">
                                    <div className="helpdesk-advantage-item">
                                        <div className="helpdesk-advantage-item-content">
                                            <div className="helpdesk-advantage-item-icon">
                                                <p className="typo-21-nm typo-medium">고객관리 솔루션 하나로 통합</p>
                                                <div className="helpdesk-icon-img">
                                                    <img src={DeskIcon3} alt="고객관리 솔루션 하나로 통합" />
                                                </div>
                                            </div>
                                            <div className="helpdesk-advantage-item-text">
                                                <ul>
                                                    <li className="typo-16 helpdesk-desc">이력관리로 고객 민원 감소</li>
                                                    <li className="typo-16 helpdesk-desc">모든 문의를 한 곳에서 관리</li>
                                                    <li className="typo-16 helpdesk-desc">일관성 있는 답변으로 만족도 향상</li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="helpdesk-advantage-item">
                                        <div className="helpdesk-advantage-item-content">
                                            <div className="helpdesk-advantage-item-icon">
                                                <p className="typo-21-nm typo-medium">중소기업 맞춤 간소화</p>
                                                <div className="helpdesk-icon-img">
                                                    <img src={DeskIcon2} alt="중소기업 맞춤 간소화" />
                                                </div>
                                            </div>
                                            <div className="helpdesk-advantage-item-text">
                                                <ul>
                                                    <li className="typo-16 helpdesk-desc">초기설정이 간단하여 교육 불필요</li>
                                                    <li className="typo-16 helpdesk-desc">담당자별 업무현황 한 눈에 파악</li>
                                                    <li className="typo-16 helpdesk-desc">인력 자원 효율 배분</li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="helpdesk-advantage-item">
                                        <div className="helpdesk-advantage-item-content">
                                            <div className="helpdesk-advantage-item-icon">
                                                <p className="typo-21-nm typo-medium">그룹웨어 사용 시 Free</p>
                                                <div className="helpdesk-icon-img">
                                                    <img src={DeskIcon1} alt="그룹웨어 사용 시 Free" />
                                                </div>
                                            </div>
                                            <div className="helpdesk-advantage-item-text">
                                                <ul>
                                                    <li className="typo-16 helpdesk-desc">한비로 그룹웨어 이용 고객<br />
                                                        헬프데스크 기능 무료 제공</li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </FadeInSection>
                        
                    </div>
                </div>

                <div className="helpdesk-block" id="ai-phone">
                    <div className="fit-wth">
                        <FadeInSection>
                            <div className="helpdesk-ai-phone">
                                <div className="helpdesk-title">
                                    <p className="typo-32-mb">AI 전화</p>
                                    <p className="typo-21-nm">PC팝업을 통하여 고객정보를 미리확인하고, 고객과의 모든 통화 이력을 저장·관리하는 솔루션입니다.</p>
                                    <p className="typo-21-nm">AI 기술을 통하여 통화 내용을 텍스트로 추출하고 번역 및 요약 기능을 제공합니다.</p>
                                </div>

                                <div className="helpdesk-content">
                                    <div className="helpdesk-item">
                                        <div className="helpdesk-item-content">
                                            <div className="helpdesk-item-icon">
                                                <p className="typo-21 typo-medium">전화 수신 팝업</p>
                                                <ul className="helpdesk-check-list">
                                                    <li className="typo-16 helpdesk-desc">PC 팝업으로 고객 정보를 사전에 확인하고,  과거 통화 이력을 참고하여 응대합니다.</li>
                                                    <li className="typo-16 helpdesk-desc">미등록 번호를 기존 고객 연락처와 자동으로 연동하여,  실시간으로 정보가 업데이트되도록 합니다.</li>
                                                    <li className="typo-16 helpdesk-desc">통화 종료 후 저장을 누르면, 통화 내용이 녹취 파일로 보관됩니다.</li>
                                                </ul>
                                            </div>
                                            <div className="helpdesk-item-img">
                                                <img src="https://hanbiro.com/assets/images/cloud/helpdesk-call-crmcall-605x350.png" />
                                            </div>
                                        </div>
                                    </div>

                                    <div className="helpdesk-item">
                                        <div className="helpdesk-item-content">
                                            <div className="helpdesk-item-icon">
                                                <p className="typo-21 typo-medium">전화 이력 관리 화면</p>
                                                <ul className="helpdesk-check-list">
                                                    <li className="typo-16 helpdesk-desc">통화 이력에 대하여 녹취파일 & 메모 를 확인합니다.</li>
                                                    <li className="typo-16 helpdesk-desc">통화 내용을 텍스트로 변환한 후, 요약 및 번역하여 보여줍니다.</li>
                                                    <li className="typo-16 helpdesk-desc">부재중 전화 이력을 확인합니다.</li>
                                                </ul>
                                            </div>
                                            <div className="helpdesk-item-img">
                                                <img src="https://hanbiro.com/assets/images/cloud/helpdesk-call-view-605x350.png" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </FadeInSection>
                        
                    </div>
                </div>

                <div className="helpdesk-block" id="ticket">
                    <div className="fit-wth">
                        <FadeInSection>
                            <div className="helpdesk-ticket">
                                <div className="helpdesk-title">
                                    <p className="typo-32-mb">티켓</p>
                                    <p className="typo-21-nm">고객이 보낸 메일을 티켓으로 자동 등록합니다.</p>
                                    <p className="typo-21-nm">담당자 배정부터 상태 변경, 답변 처리까지 체계적으로 관리합니다.</p>
                                    <p className="typo-21-nm">티켓은 진행 단계별로 명확히 구분되어 업무 누락 없이 신속하게 대응합니다.</p>
                                </div>

                                <div className="helpdesk-content">
                                    <div className="helpdesk-item">
                                        <div className="helpdesk-item-content">
                                            <div className="helpdesk-item-icon">
                                                <p className="typo-21 typo-medium">티켓 조회 화면</p>
                                                <ul className="helpdesk-check-list">
                                                    <li className="typo-16 helpdesk-desc">고객이 대표메일로 문의한 것을 티켓화합니다.</li>
                                                    <li className="typo-16 helpdesk-desc">각 문의에 대한 담당자와 우선순위를 한눈에 확인합니다.</li>
                                                    <li className="typo-16 helpdesk-desc">배정되지 않은 티켓을 따로 표기하여 누락되지 않도록 지원합니다.</li>
                                                </ul>
                                            </div>
                                            <div className="helpdesk-item-img">
                                                <img src="https://hanbiro.com/assets/images/cloud/helpdesk-ticket-view-605x350.png" />
                                            </div>
                                        </div>
                                    </div>

                                    <div className="helpdesk-item">
                                        <div className="helpdesk-item-content">
                                            <div className="helpdesk-item-icon">
                                                <p className="typo-21 typo-medium">티켓 요약 & 번역 </p>
                                                <ul className="helpdesk-check-list">
                                                    <li className="typo-16 helpdesk-desc">고객이 문의한 내용에 대해 요약 및 번역 기능을 제공합니다.</li>
                                                    <li className="typo-16 helpdesk-desc">고객의 문의사항을 처리할 담당자를 자동 할당 및 수동 배정합니다.</li>
                                                    <li className="typo-16 helpdesk-desc">각 문의에 대한 카테고리 및 상태를 변경합니다.</li>
                                                    <li className="typo-16 helpdesk-desc">해당 용어는 회사에 맞게 커스텀합니다.</li>
                                                </ul>
                                            </div>
                                            <div className="helpdesk-item-img">
                                                <img src="https://hanbiro.com/assets/images/cloud/helpdesk-ticket-view-ai-605x350.png" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </FadeInSection>
                    </div>
                </div>

                <div className="helpdesk-block" id="livechat">
                    <div className="fit-wth">
                        <FadeInSection>
                            <div className="helpdesk-livechat">
                                <div className="helpdesk-title">
                                    <p className="typo-32-mb">라이브챗</p>
                                    <p className="typo-21-nm">라이브챗을 통해 고객과 실시간 상담한 내역을 저장하고 관리합니다.</p>
                                    <p className="typo-21-nm">상담 이력은 자동으로 저장되며 , AI가 대화 내용을 요약 해 핵심을 빠르게 파악합니다.</p>
                                </div>

                                <div className="helpdesk-content">
                                    <div className="helpdesk-item">
                                        <div className="helpdesk-item-content">
                                            <div className="helpdesk-item-icon">
                                                <p className="typo-21 typo-medium">라이브챗 조회</p>
                                                <ul className="helpdesk-check-list">
                                                    <li className="typo-16 helpdesk-desc">고객과의 라이브챗 상담 내용을 확인합니다.</li>
                                                    <li className="typo-16 helpdesk-desc">상담 내용을 요약하여 간략하게 제공합니다.</li>
                                                    <li className="typo-16 helpdesk-desc">상담 내용을 기존 고객과 연동하면 고객관리`{'>'}`영업활동 메뉴에 히스토리로 표출됩니다.</li>
                                                    <li className="typo-16 helpdesk-desc">상담내용에 대하여 요약·번역 기능을 제공합니다.</li>
                                                </ul>
                                            </div>
                                            <div className="helpdesk-item-img">
                                                <img src="https://hanbiro.com/assets/images/cloud/helpdesk-livechat-view-605x350.png" />
                                            </div>
                                        </div>
                                    </div>

                                    <div className="helpdesk-item">
                                        <div className="helpdesk-item-content">
                                            <div className="helpdesk-item-icon">
                                                <p className="typo-21 typo-medium">라이브챗 요약</p>
                                                <ul className="helpdesk-check-list">
                                                    <li className="typo-16 helpdesk-desc">고객과의 라이브챗 상담 내용을 날짜로 검색하여 해당 일자의 <br/>요약 내용을 한눈에 봅니다.</li>
                                                </ul>
                                            </div>
                                            <div className="helpdesk-item-img">
                                                <img src="https://hanbiro.com/assets/images/cloud/helpdesk-livechat-log-605x350.png" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </FadeInSection>
                        
                    </div>
                </div>

                <div className="helpdesk-block pb-60" id="customer">
                    <div className="fit-wth">
                        <FadeInSection>
                            <div className="helpdesk-customer">
                                <div className="helpdesk-title">
                                    <p className="typo-32-mb">고객관리</p>
                                    <p className="typo-21-nm">고객 정보를 등록하고 , 상담/문의/미팅 등 고객의 모든 활동 이력을 헬프데스크 한 곳에서 통합 관리합니다.</p>
                                    <p className="typo-21-nm">고객의 이력을 한 눈에 파악하여 , 일관된 고객 응대를 지원합니다.</p>
                                </div>

                                <div className="helpdesk-content">
                                    <div className="helpdesk-item">
                                        <div className="helpdesk-item-content">
                                            <div className="helpdesk-item-icon">
                                                <p className="typo-21 typo-medium">고객 정보 등록 및 조회</p>
                                                <ul className="helpdesk-check-list">
                                                    <li className="typo-16 helpdesk-desc">등록된 고객에 대해 고객그룹과 담당자를 확인합니다.</li>
                                                    <li className="typo-16 helpdesk-desc">등록된 고객의 대표 번호와 메일주소를 확인합니다.</li>
                                                    <li className="typo-16 helpdesk-desc">통합검색을 통해 이름, 이메일, 전화, 주소, 담당자, 고객그룹 등 을 검색합니다.</li>
                                                </ul>
                                            </div>
                                            <div className="helpdesk-item-img">
                                                <img src="https://hanbiro.com/assets/images/cloud/helpdesk-customers-view-add-605x350.png" />
                                            </div>
                                        </div>
                                    </div>

                                    <div className="helpdesk-item">
                                        <div className="helpdesk-item-content">
                                            <div className="helpdesk-item-icon">
                                                <p className="typo-21 typo-medium">고객별 히스토리 조회</p>
                                                <ul className="helpdesk-check-list">
                                                    <li className="typo-16 helpdesk-desc">해당 고객과 진행한 활동이력을 모아봅니다.</li>
                                                    <li className="typo-16 helpdesk-desc">고객의 정보 및 특이사항에 대해 메모를 남깁니다.</li>
                                                    <li className="typo-16 helpdesk-desc">고객과 주고받은 첨부파일들을 모아봅니다.</li>
                                                </ul>
                                            </div>
                                            <div className="helpdesk-item-img">
                                                <img src="https://hanbiro.com/assets/images/cloud/helpdesk-customers-view-605x350.png" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </FadeInSection>
                    </div>
                </div>

                <div className="helpdesk-block helpdesk-knowledge pb-60 pt-60" id="knowledge">
                    <div className="fit-wth">
                        <FadeInSection>
                            <div className="helpdesk-title">
                                <p className="typo-32-mb">지식창고·기업전용 LLM챗봇</p>
                                <p className="typo-21-nm">기업 내부의 방대한 문서와 자료를 체계적으로 관리합니다.</p>
                                <p className="typo-21-nm">지식창고에 업로드 한 자료를 기반으로, 직원이 질문하면 LLM챗봇이 즉시 답변하는 맞춤형 서비스입니다.</p>
                                <p className="typo-21-nm">이를 통해 필요한 정보를 빠르게 찾아 업무 효율을 높입니다.</p>
                            </div>

                            <div className="helpdesk-content">
                                <div className="helpdesk-item-img">
                                    <img src="https://hanbiro.com/assets/images/cloud/helpdesk-knowledgebase-view-605x350.png" />
                                </div>
                            </div>

                            <div className="helpdesk-btn-gr">
                                <a className="helpdesk-url-btn typo-14" href="https://hanbiro.com/#/chatbot">
                                    <button className="btn--default btn--primary">
                                        <img src={DeskIcon6} width={18} height={18} /> 
                                        &nbsp; Help 챗봇 바로가기 &nbsp;
                                        <img src={DeskIcon7} width={18} height={18} />
                                    </button>
                                </a>
                            </div>
                        </FadeInSection>
                    </div>
                </div>
        </div>
    );
}

export function HelpDeskContent() {
    return (
        <>
            <HelpDeskBanner />
            <HelpDeskBody />
        </>
    );
}

function HelpDeskNew() {
    useEffect(() => {
        if ("scrollRestoration" in window.history) {
            window.history.scrollRestoration = "manual";
        }
        window.scrollTo(0, 0);
    }, []); 

    return (
        <div>
            <NavButton
                lang="ko"
                option={{
                    logo: "https://hanbiro.com/cloud/library/banner/hanbiro.svg",
                    link: "https://hanbiro.com/",
                    color: { backgroundColor: "#7061FF" },
                    itemNavClass: "item-nav nav-pur",
                    menuListProduct: "menu-list-product-item",
                    menuListVora: "vora",
                    menuListGroupware: "groupware",
                    titleTab: "mb-3",
                }}
            />
            <HelpDeskContent />
            <Footer
                option={{
                    textColor: "text-color external-link text-pur-color",
                    textlinkColor: "text-color text-pur-color",
                }}
            />
        </div>
    );
}

export default HelpDeskNew;
